/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { R500 } from '@atlaskit/theme/colors';
var requiredIndicatorStyles = css({
  color: "var(--ds-text-danger, ".concat(R500, ")"),
  paddingInlineStart: "var(--ds-space-025, 2px)"
});
export default function RequiredIndicator() {
  return jsx("span", {
    css: requiredIndicatorStyles,
    "aria-hidden": true
  }, "*");
}